<template>
  <div class="pointer">
    <vue-dropzone
      :class="styleClass"
      ref="myVueDropzone"
      id="dropzone"
      @vdropzone-sending="beforeUpload"
      @vdropzone-success="afterUploadSuccess"
      @vdropzone-error="afterUploadError"
      @vdropzone-file-added="afterFileAdded"
      :duplicate-check="true"
      :options="dropzoneOptions"
      :use-custom-slot="true"
    >
      <template v-if="src && !addingFile">
        <img :src="src.url" class="w-100" alt="Company profile image" />
        <i class="fa fa-pencil" aria-hidden="true" />
        <i class="fa fa-icon" aria-hidden="true" @click.stop="deleteImage">
          <span class="md-icon-clear" />
        </i>
      </template>
      <template v-else-if="!addingFile">
        <div class="upload-wrapper">
          <div>
            <div><i class="fa fa-upload" /></div>
            <div class="upload-label">{{ label }}</div>
            <div class="upload-recommended" v-if="recommended">
              {{ recommended }}
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <!-- Show any html so the default html from dropzone package is hidden -->
        <div />
      </template>
    </vue-dropzone>
    <div class="error-text">{{ error }}</div>
  </div>
</template>

<script>
import axios from "axios";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import toastr from "toastr";

export default {
  components: {
    vueDropzone: vue2Dropzone
  },
  props: {
    label: { type: String, default: "Browse" },
    recommended: { type: String, default: "" },
    maxFiles: { type: Number, default: 1 },
    src: { type: Object, default: null },
    styleClass: { type: String, default: "square-upload " },
    strategy: { type: String, default: "image" }
  },
  data() {
    return {
      fd: [],
      dropzoneOptions: {
        url:
          `${process.env.VUE_APP_API_URL}` +
          (this.strategy === "cover" ? "files/upload" : "uploads"),
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        thumbnailWidth: null,
        maxFilesize: 2,
        maxFiles: this.maxFiles,
        paramName: "image"
      },
      addingFile: false,
      error: ""
      // errors: new Errors()
    };
  },
  methods: {
    beforeUpload(file, xhr, formData) {
      if (this.strategy) {
        formData.append("strategy", this.strategy);
      }
    },
    afterUploadSuccess(file, response) {
      this.$refs.myVueDropzone.removeAllFiles();
      this.$emit("update", response);
    },
    afterUploadError() {
      this.$refs.myVueDropzone.removeAllFiles();
      this.error = `Couldn't upload photo`;
    },
    afterFileAdded() {
      this.addingFile = true;
    },
    afterQueueComplete() {
      this.$refs.myVueDropzone.removeAllFiles();
      this.addingFile = false;
    },
    deleteImage() {
      const url = `${process.env.VUE_APP_API_URL}uploads/${this.src.id}`;
      axios.delete(url).then(() => {
        toastr.success("Successfully deleted image");
        this.$emit("update");
      });
    }
  }
};
</script>
<style>
.vue-dropzone {
  background: #ffffff;
  border: 1px dashed #e0e5ea;
  box-sizing: border-box;
  border-radius: 3px;
  height: 100%;
  padding: 15px;
}
.upload-wrapper .fa-upload {
  color: #808d98;
}

.upload-recommended,
.upload-label {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  letter-spacing: 0.4px;
}
.upload-label {
  text-decoration-line: underline;
  margin-bottom: 8px;
}
.square-upload {
  display: flex;
  justify-content: center;
  align-items: center;
}
.image-upload .dz-image img {
  background-repeat: no-repeat;
  background-size: contain;
  max-width: 150px;
}
.image-upload-wider .dz-image img {
  background-repeat: no-repeat;
  background-size: contain;
  max-width: 350px;
}
</style>
